'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.values = exports.N = exports.X = exports.R = exports.D = exports.P = exports.K = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _params;

exports.getCaption = getCaption;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @Conf
// #hasDoc=true

// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-01-07T17:38:05Z                      #

// ##############################################################

/**
 * Typ adresy.
 */

/**
 * Klasická adresa.
 */
var K = exports.K = 'K';

/**
 * Poštovní přihrádka.
 */
var P = exports.P = 'P';

/**
 * Dodávací schrána.
 */
var D = exports.D = 'D';

/**
 * Poste restante.
 */
var R = exports.R = 'R';

/**
 * Nestrukturovaná adresa.
 */
var X = exports.X = 'X';

/**
 * Neuvedena.
 */
var N = exports.N = 'N';

/**
 * Seznam všech hodnot.
 */
var values = exports.values = [K, P, D, R, X, N];

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
var params = (_params = {}, (0, _defineProperty3.default)(_params, K, { caption: 'Klasická adresa.' }), (0, _defineProperty3.default)(_params, P, { caption: 'Poštovní přihrádka.' }), (0, _defineProperty3.default)(_params, D, { caption: 'Dodávací schrána.' }), (0, _defineProperty3.default)(_params, R, { caption: 'Poste restante.' }), (0, _defineProperty3.default)(_params, X, { caption: 'Nestrukturovaná adresa.' }), (0, _defineProperty3.default)(_params, N, { caption: 'Neuvedena.' }), _params);

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
function getCaption(value) {
  return params[value].caption;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9saWIvYXBpL2dlbi9hZHJlc3kvdjEvVHlwQWRyZXN5LmpzeCJdLCJuYW1lcyI6WyJnZXRDYXB0aW9uIiwiSyIsIlAiLCJEIiwiUiIsIlgiLCJOIiwidmFsdWVzIiwicGFyYW1zIiwiY2FwdGlvbiIsInZhbHVlIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7O1FBeUVnQkEsVSxHQUFBQSxVOzs7O0FBekVoQjtBQUNBOztBQUVBOztBQUVBOztBQUVBOztBQUVBOztBQUVBOzs7O0FBSUE7OztBQUdPLElBQU1DLGdCQUFJLEdBQVY7O0FBRVA7OztBQUdPLElBQU1DLGdCQUFJLEdBQVY7O0FBRVA7OztBQUdPLElBQU1DLGdCQUFJLEdBQVY7O0FBRVA7OztBQUdPLElBQU1DLGdCQUFJLEdBQVY7O0FBRVA7OztBQUdPLElBQU1DLGdCQUFJLEdBQVY7O0FBRVA7OztBQUdPLElBQU1DLGdCQUFJLEdBQVY7O0FBRVA7OztBQUdPLElBQU1DLDBCQUFTLENBQ2xCTixDQURrQixFQUVsQkMsQ0FGa0IsRUFHbEJDLENBSGtCLEVBSWxCQyxDQUprQixFQUtsQkMsQ0FMa0IsRUFNbEJDLENBTmtCLENBQWY7O0FBU1A7OztBQUdBLElBQU1FLCtEQUNEUCxDQURDLEVBQ0csRUFBQ1EsU0FBUyxrQkFBVixFQURILDBDQUVEUCxDQUZDLEVBRUcsRUFBQ08sU0FBUyxxQkFBVixFQUZILDBDQUdETixDQUhDLEVBR0csRUFBQ00sU0FBUyxtQkFBVixFQUhILDBDQUlETCxDQUpDLEVBSUcsRUFBQ0ssU0FBUyxpQkFBVixFQUpILDBDQUtESixDQUxDLEVBS0csRUFBQ0ksU0FBUyx5QkFBVixFQUxILDBDQU1ESCxDQU5DLEVBTUcsRUFBQ0csU0FBUyxZQUFWLEVBTkgsV0FBTjs7QUFTQTs7OztBQUlPLFNBQVNULFVBQVQsQ0FBb0JVLEtBQXBCLEVBQTJCO0FBQzlCLFNBQU9GLE9BQU9FLEtBQVAsRUFBY0QsT0FBckI7QUFDSCIsImZpbGUiOiJUeXBBZHJlc3kuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAQ29uZlxuLy8gI2hhc0RvYz10cnVlXG5cbi8vICMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjXG5cbi8vICMgICAgICAgICAgICAgR0VORVJPVkFOw50gS8OTRCwgTkVNT0RJRklLT1ZBVCEhISEgICAgICAgICAgICAgICNcblxuLy8gIyAgICAgICAgICAgICAgICAgIDIwMjUtMDEtMDdUMTc6Mzg6MDVaICAgICAgICAgICAgICAgICAgICAgICNcblxuLy8gIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyNcblxuLyoqXG4gKiBUeXAgYWRyZXN5LlxuICovXG5cbi8qKlxuICogS2xhc2lja8OhIGFkcmVzYS5cbiAqL1xuZXhwb3J0IGNvbnN0IEsgPSAnSyc7XG5cbi8qKlxuICogUG/FoXRvdm7DrSBwxZlpaHLDoWRrYS5cbiAqL1xuZXhwb3J0IGNvbnN0IFAgPSAnUCc7XG5cbi8qKlxuICogRG9kw6F2YWPDrSBzY2hyw6FuYS5cbiAqL1xuZXhwb3J0IGNvbnN0IEQgPSAnRCc7XG5cbi8qKlxuICogUG9zdGUgcmVzdGFudGUuXG4gKi9cbmV4cG9ydCBjb25zdCBSID0gJ1InO1xuXG4vKipcbiAqIE5lc3RydWt0dXJvdmFuw6EgYWRyZXNhLlxuICovXG5leHBvcnQgY29uc3QgWCA9ICdYJztcblxuLyoqXG4gKiBOZXV2ZWRlbmEuXG4gKi9cbmV4cG9ydCBjb25zdCBOID0gJ04nO1xuXG4vKipcbiAqIFNlem5hbSB2xaFlY2ggaG9kbm90LlxuICovXG5leHBvcnQgY29uc3QgdmFsdWVzID0gW1xuICAgIEssXG4gICAgUCxcbiAgICBELFxuICAgIFIsXG4gICAgWCxcbiAgICBOXG5dO1xuXG4vKipcbiAqIE1hcGEgZW51bXUgbmEgb2JqZWt0IHMgcG9kcm9ibm9zdG1pIG8gZW51bXUuXG4gKi9cbmNvbnN0IHBhcmFtcyA9IHtcbiAgICBbS106IHtjYXB0aW9uOiAnS2xhc2lja8OhIGFkcmVzYS4nfSxcbiAgICBbUF06IHtjYXB0aW9uOiAnUG/FoXRvdm7DrSBwxZlpaHLDoWRrYS4nfSxcbiAgICBbRF06IHtjYXB0aW9uOiAnRG9kw6F2YWPDrSBzY2hyw6FuYS4nfSxcbiAgICBbUl06IHtjYXB0aW9uOiAnUG9zdGUgcmVzdGFudGUuJ30sXG4gICAgW1hdOiB7Y2FwdGlvbjogJ05lc3RydWt0dXJvdmFuw6EgYWRyZXNhLid9LFxuICAgIFtOXToge2NhcHRpb246ICdOZXV2ZWRlbmEuJ31cbn07XG5cbi8qKlxuICogTmHEjXRlbsOtIHBvcGlza3UgZW51bXUuXG4gKiBAcmV0dXJuIHBvcGlzZWsgZW51bXVcbiAqL1xuZXhwb3J0IGZ1bmN0aW9uIGdldENhcHRpb24odmFsdWUpIHtcbiAgICByZXR1cm4gcGFyYW1zW3ZhbHVlXS5jYXB0aW9uO1xufSJdfQ==